import { DatePicker as AntdDatePicker, ConfigProvider } from 'antd'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { Form } from 'react-bootstrap'
import colors from '../../theme/colors'

dayjs.extend(customParseFormat)

const parsePickerDate = (dateStr) => {
    if (!dateStr) return null
    const parsed = dayjs(dateStr, ['DD/MM/YYYY', 'YYYY-MM-DD'], true)
    return parsed.isValid() ? parsed.startOf('day') : null
}

export default function DatePicker(props) {

    const { label_name, placeholder, name, value, minDate, onChange, onBlur, error, mandatory, reference, tabIndex, disabled } = props
    const parsedValue = parsePickerDate(value)
    const parsedMinDate = parsePickerDate(minDate)
    return (
        <>
            <Form.Group className="mb-2" controlId={name}>
                {label_name === '' ? '' : <Form.Label className={mandatory ? 'form_label_red' : 'form_label'}>{`${label_name}${mandatory ? '*' : ''}`}</Form.Label>}
                <ConfigProvider
                    theme={{
                        components: {
                            DatePicker: {
                                borderColor: 'hsl(0, 0%, 80%)',
                                activeBorderColor: colors.primary,
                                activeOutlineColor: 'none',
                                hoverBorderColor: 'none',
                                hoverBg: 'transparent',
                                activeShadow: 'none',
                                activeBg: 'transparent',
                                zIndexPopup: '99999',
                            },
                        },
                        token: {
                            colorBorder: '#ccc',
                            fontFamily: 'Lexend Deca'
                        },
                    }}
                >
                    <AntdDatePicker
                        ref={reference}
                        className='form-control form_input'
                        placeholder={placeholder}
                        format={'DD/MM/YYYY'}
                        name={name}
                        value={parsedValue}
                        disabled={disabled}
                        disabledDate={(current) => {
                            if (!current || !parsedMinDate) return false
                            return current.startOf('day').isBefore(parsedMinDate, 'day')
                        }}
                        onChange={onChange}
                        onBlur={onBlur}
                        tabIndex={tabIndex}
                    />
                </ConfigProvider>
                {error}
            </Form.Group>
        </>
    )
}
